/**
 * ProcessDetailPage — legacy standalone route at
 * `/f/:folderId/processes/:processId`.
 *
 * Now redirects to the canonical dashboard URL per the URL grammar
 * (see docs/architecture/dashboard-routing.md). The redirect target
 * is `/dashboard/:folderId/inventory/processes/:processId`. Old
 * deep-links keep working — they just normalise on entry.
 *
 * Kept around for back-compat with shared links sent via email /
 * Slack / etc. The actual detail rendering happens inside the
 * dashboard via the embedded takeover.
 */

import React from 'react'
import { useParams } from '@tanstack/react-router'

export const ProcessDetailPage: React.FC = () => {
  const params = useParams({ strict: false }) as {
    folderId?: string
    processId?: string
  }
  const folderId = params.folderId ?? ''
  const processId = params.processId ?? ''

  React.useEffect(() => {
    if (!folderId || !processId) {
      window.location.replace('/dashboard')
      return
    }
    // The dashboard router lives at basepath '/dashboard'.
    const canonical = `/dashboard/${encodeURIComponent(folderId)}/inventory/processes/${encodeURIComponent(processId)}`
    window.location.replace(canonical)
  }, [folderId, processId])

  return (
    <div className="min-h-screen bg-[color:var(--color-ink-50)] flex items-center justify-center text-[color:var(--color-ink-500)] text-sm">
      Redirecting…
    </div>
  )
}

export default ProcessDetailPage
